import { useEffect, useState } from 'react';
import { useLogger } from '../context';
import { AssetHelper } from '../helper/assetHelper';
import { getAssetUrl } from './get-asset-url';
import { useBreakpoint } from './use-breakpoint';
import { useViewbox } from './use-viewbox';
import { Animation, ThemeScroll } from '../FeatureAppTypes';

type ImageUrlType = {
  imagesUrls: string[];
  alt: string;
};

export const useImagesUrl = (animation: Animation, theme: ThemeScroll): ImageUrlType => {
  const [imagesUrls, setUrls] = useState<string[]>([]);

  const {
    images,
    numberOfImages,
    useEveryNthImage,
    fallback: { alt },
  } = animation;

  const logger = useLogger();
  const breakpoint = useBreakpoint(theme);
  const { orientation } = useViewbox();

  useEffect(() => {
    if (breakpoint !== 0) {
      const imageSrc = AssetHelper.generateImageUrls(
        images,
        orientation,
        numberOfImages,
        useEveryNthImage,
        logger,
      );
      setUrls(imageSrc.map((image) => getAssetUrl(image, { width: breakpoint })));
    }
  }, [numberOfImages, useEveryNthImage, images, breakpoint, orientation]);

  return { imagesUrls, alt };
};
